import TextsOnly from 'containers/Slices/TextsOnly';
import ImageWithTitle from 'containers/Slices/ImageWithTitle';
import TwoColumns from 'containers/Slices/TwoColumns';
import AuxBanner from 'containers/Slices/AuxBanner';
import HTMLTextsOnly from 'containers/Slices/HTMLTextsOnly';
import JobsBlock from 'containers/Slices/JobsBlock';
import HolidayOffers from 'containers/Slices/HolidayOffers';
import ContactWithButton from 'containers/Slices/ContactWithButton';
import FourColumnsCard from 'containers/Slices/FourColumnsCard';
import SupportHotline from 'containers/Slices/SupportHotline';
import SupportInformation from 'containers/Slices/SupportInformation';
import FAQ from 'containers/Slices/FAQ';
import GalleryTabSlice from 'containers/Slices/GalleryTabSlice';
import LargeReviewsCarousel from 'containers/Slices/ImprovementSlices/LargeReviewsCarousel';
import SmallReviewsCarousel from 'containers/Slices/ImprovementSlices/SmallReviewsCarousel';
import ProductBanner from 'containers/Slices/ProductBanner';
import GiveawayBanner from 'containers/Slices/GiveawayBanner';
import ProductsCarousel from 'containers/Slices/ImprovementSlices/ProductsCarousel';
import EnquiryForm from 'containers/Slices/EnquiryForm';
import YoutubeVideo from 'containers/Slices/YoutubeVideo';
import UltralabsVideo from 'containers/Slices/UltralabsVideo';
import GetInTouch from 'containers/Slices/GetInTouch';
import UltralabStep from 'containers/Slices/UltralabStep';
import TwoColumnsVideo from 'containers/Slices/TwoColumnsVideo';
import UltralabsGallery from 'containers/Slices/UltralabsGallery';
import WorkshopImages from 'containers/Slices/WorkshopImages';
import EmbedGoogleForm from 'containers/Slices/EmbedGoogleForm';
import VideoWebM from 'containers/Slices/VideoWebM';
import SalePage from 'containers/Slices/SalePage';
import DriversSlice from 'containers/Slices/DriversSlice';

const renderAuxSlices = (block, type, index) => {
  switch (type) {
    case 'texts_only':
      return <TextsOnly block={block} key={`${type}-${index}`} />;
    case 'html_text_only':
      return <HTMLTextsOnly block={block} key={`${type}-${index}`} />;
    case 'two_columns':
      return <TwoColumns block={block} key={`${type}-${index}`} />;
    case 'image_with_title':
      return <ImageWithTitle block={block} key={`${type}-${index}`} />;
    case 'aux_banner':
      return <AuxBanner block={block} key={`${type}-${index}`} />;
    case 'workshop_images':
      return <WorkshopImages block={block} key={`${type}-${index}`} />;
    case 'embed_google_form':
      return <EmbedGoogleForm block={block} key={`${type}-${index}`} />;
    case 'jobs_block':
      return <JobsBlock block={block} key={`${type}-${index}`} />;
    case 'holiday_offers':
      return <HolidayOffers block={block} key={`${type}-${index}`} />;
    case 'contact_with_button':
      return <ContactWithButton block={block} key={`${type}-${index}`} />;
    case 'four_columns_card':
      return <FourColumnsCard block={block} key={`${type}-${index}`} />;
    case 'support_hotline':
      return <SupportHotline block={block} key={`${type}-${index}`} />;
    case 'enquiry_form':
      return <EnquiryForm block={block} key={`${type}-${index}`} />;
    case 'support_information':
      return <SupportInformation block={block} key={`${type}-${index}`} />;
    case 'faq':
      return <FAQ block={block} key={`${type}-${index}`} />;
    case 'gallery_tab':
      return <GalleryTabSlice block={block} key={`${type}-${index}`} />;
    case 'reviews_carousel':
      if (block?.primary.carousel_item_size === 'Large') {
        return <LargeReviewsCarousel block={block} key={`${type}-${index}`} />;
      } else {
        return <SmallReviewsCarousel block={block} key={`${type}-${index}`} />;
      }
    case 'carousel_by_product':
      return <ProductsCarousel block={block} key={`${type}-${index}`} />;
    case 'product_banner':
      return <ProductBanner block={block} key={`${type}-${index}`} />;
    case 'giveaway_banner':
      return <GiveawayBanner block={block} key={`${type}-${index}`} />;
    case 'youtube_video':
      return <YoutubeVideo block={block} key={`${type}-${index}`} />;
    case 'ultralabs_video':
      return <UltralabsVideo block={block} key={`${type}-${index}`} />;
    case 'get_in_touch':
      return <GetInTouch block={block} key={`${type}-${index}`} />;
    case 'ultralabs_steps':
      return <UltralabStep block={block} key={`${type}-${index}`} />;
    case 'two_columns_video':
      return <TwoColumnsVideo block={block} key={`${type}-${index}`} />;
    case 'ultralabs_gallery':
      return <UltralabsGallery block={block} key={`${type}-${index}`} />;
    case 'video_webm':
      return <VideoWebM block={block} key={`${type}-${index}`} />;
    case 'sale_page_top_banner':
      return <SalePage block={block} key={`${type}-${index}`}  />;
    case 'sale_page_cards':
      return <SalePage block={block} key={`${type}-${index}`}  />;
    case 'drivers_slice':
      return <DriversSlice block={block} key={`${type}-${index}`}  />;
    default:
      return '';
  }
};

export default renderAuxSlices;
